module.exports = __webpack_public_path__ + "img/6-Stepp-Roadside-Information-Page-MVP.132bd0a8.png";